import Image from '@jetshop/ui/Image';
import ProductLink from '@jetshop/ui/ProductLink';
import theme from '@jetshop/ui/utils/theme';
import React from 'react';
import styled from 'react-emotion';
import { Price } from '../../Price/';
import { VatContext } from '../../Price/VatContext';
import { StockStatus, StockStatusWrapper } from '../../ProductPage/ProductPage';
import { useStocklevelCalc } from '../../ProductPage/useStocklevelCalc';
import { SharedCartBuyButton } from './SharedCartBuyButton';

export const SharedCartProduct = ({
  product,
  quantity,
  incQuantity,
  decQuantity,
}) => {
  const { productStockStatus } = useStocklevelCalc({
    product: product,
  });

  return (
    <Wrapper>
      <ImageWrapper>
        <StyledImage
          src={product.images[0] && product.images[0].url}
          alt={product.name}
        />
      </ImageWrapper>

      <ItemDetails>
        <ProductLink product={product}>
          <ProductName>{product.name}</ProductName>
        </ProductLink>
        <ProductArtNo>Art.nr: {product.articleNumber}</ProductArtNo>
      </ItemDetails>
      <PriceDetails>
        <VatContext.Consumer>
          {({ incVat }) => (
            <LinePrice
              includeVat={incVat}
              price={product.price}
              previousPrice={product.previousPrice}
            />
          )}
        </VatContext.Consumer>

        <StockStatus stockStatus={productStockStatus} />
      </PriceDetails>

      <QuantityWrapper>
        <AdjustQty>
          <button disabled={quantity === 1} onClick={decQuantity}>
            -
          </button>
          <span>{quantity}</span>
          <button onClick={incQuantity}>+</button>
        </AdjustQty>
      </QuantityWrapper>
      <SharedCartBuyButton product={product} quantity={quantity} />
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 1rem;
  background: white;
  ${({ theme }) => theme.above.sm} {
    align-items: initial;
    grid-template-columns: 1fr 2fr 1fr 0.5fr 80px;
  }
`;

const ProductName = styled('h2')`
  max-width: 220px;
  word-break: break-word;

  color: black;
  font-size: 1.2rem;
  text-transform: uppercase;
  font-family: ${theme('fontFamilies.body')};
  font-weight: normal;
`;

const ProductArtNo = styled('span')`
  max-width: 220px;
  word-break: break-word;

  display: block;
  color: #a5a5a5;
  font-size: 1rem;
`;

const ItemDetails = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0 1rem;
  ${({ theme }) => theme.above.sm} {
    padding: 1rem 0;
  }
`;

const LinePrice = styled(Price)`
  max-width: 220px;
  word-break: break-word;

  font-weight: 600;
  font-family: ${theme('fontFamilies.heavy')};
  text-align: center;

  ${Price.New} {
    color: #ce3233;
    font-size: 1.2rem;
  }
`;

const PriceDetails = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
  padding: 0 1rem;
  ${({ theme }) => theme.above.sm} {
    padding: 1rem 0;
  }

  ${theme('below.md')} {
    text-align: left;
    font-size: 0.85rem;
  }

  ${StockStatusWrapper} {
    margin: 0;

    span {
      word-break: break-word;
      font-size: 16px;
    }
  }
`;

const ImageWrapper = styled('div')`
  position: relative;
  display: flex;
  width: 100%;
`;

const StyledImage = styled(Image)`
  flex: 1;
`;

const ProductQuantity = styled('span')`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(0.25rem, 0.5rem);
  max-width: 5ch;
  word-break: break-word;

  color: ${theme('colors.black')};
  background: ${theme('colors.white')};
  border-radius: 1rem;
  padding: 0.25rem;
  font-size: 1.2rem;
  font-family: ${theme('fontFamilies.body')};
  font-weight: normal;

  ${theme('below.md')} {
    font-size: 15px;
    margin-bottom: 0.5em;
  }
`;

const QuantityWrapper = styled('div')`
  display: flex;
  justify-content: center;
  padding: 0 1rem;
  ${({ theme }) => theme.above.sm} {
    padding: 1rem 0;
  }
`;

const AdjustQty = styled('div')`
  display: flex;
  grid-area: bottomleft;
  /* Plus/minus buttons */

  button {
    background: #f2f2f2;
    color: black;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    :focus {
      outline: none;
    }
  }

  /* Count */

  span {
    margin: 0 0.5rem;
    display: inline-block;
  }
`;
